import { Stack, useTheme } from "@mui/material";
import type { FC, PropsWithChildren } from "react";

export const CalculatorResultSurface: FC<PropsWithChildren> = ({
	children,
}) => {
	const theme = useTheme();

	return (
		<Stack
			mt={theme.spacingTokens.md}
			px={theme.spacingTokens.lg}
			pt={theme.spacingTokens.lg}
			pb={theme.bottomSpacing.stickyCta}
			sx={{ background: theme.gradients.blueHero }}
		>
			{children}
		</Stack>
	);
};
